import {
  GaugeContainer,
  GaugeValueArc,
  GaugeReferenceArc,
  useGaugeState,
} from '@mui/x-charts/Gauge';

function GaugePointer() {
  const { valueAngle, outerRadius, cx, cy } = useGaugeState();
  if (valueAngle === null) {
    return null;
  }
  const target = {
    x: cx + outerRadius * Math.sin(valueAngle),
    y: cy - outerRadius * Math.cos(valueAngle),
  };
  return (
    <g>
      <circle cx={cx} cy={cy} r={5} fill="#ff6b35" />
      <path
        d={`M ${cx} ${cy} L ${target.x} ${target.y}`}
        stroke="#ff6b35"
        strokeWidth={3}
      />
    </g>
  );
}

export default function Gauge({range, height, valueColor = '#31acee', bgColor = '#e0e0e0'}) {
  return (
    <GaugeContainer
      cornerRadius="50%"
      height={height}
      width={height}
      startAngle={-110}
      endAngle={110}
      value={range}
    >
      <GaugeReferenceArc sx={{ fill: bgColor }} />
      <GaugeValueArc sx={{ fill: valueColor }} />
      <GaugePointer />
    </GaugeContainer>
  );
}